<div class="main-box">
  <p-toast></p-toast>
  <div [formGroup]="guideForm" *ngIf="guideForm">
    <div class="submit-delete-box">
      <p-button label="Submit" (onClick)="sendForm()"></p-button>
      <p-button icon="pi pi-trash" label="Delete this guide" (onClick)="deleteGuide()" styleClass="p-button-danger"></p-button>
    </div>
    <p *ngIf="nameIsNull">
      Name is required
    </p>
    <table>
      <tr>
        <td>
          Name
        </td>
        <td>
          <input placeholder="Name" type="text" formControlName="name">
        </td>
      </tr>
      <tr>
        <td>
          Comment
        </td>
        <td>
          <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
        </td>
      </tr>
    </table>
  </div>
</div>
